import React from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

import './MobileButtons.less';

const MobileButtons = ({ handleClose, countResult, selectedFilter, onClearAll }) => (
  <div className="common-filter__sticky-row--bottom">
    {Object.keys(selectedFilter).length > 0 ? (
      <ButtonV2
        className="mobile-filter__btn mobile-filter__btn--clear"
        onClick={() => onClearAll()}
        variant="secondary"
      >
        Clear All Filters
      </ButtonV2>
    ) : (
      <ButtonV2
        className="mobile-filter__btn mobile-filter__btn--clear"
        onClick={() => {}}
        disabled
        variant="secondary"
      >
        Clear All Filters
      </ButtonV2>
    )}
    <ButtonV2
      className="mobile-filter__btn mobile-filter__btn--results"
      onClick={() => handleClose()}
      variant="primary"
    >
      {`See ${countResult} Results`}
    </ButtonV2>
  </div>
);

MobileButtons.propTypes = {
  handleClose: PropTypes.func,
  onClearAll: PropTypes.func,
  countResult: PropTypes.number,
  selectedFilter: PropTypes.shape([]),
};

export default MobileButtons;
